import { type SxProps, styled } from "@mui/material/styles"
import WavelengthLogoSvg from "./WavelengthLogo.svg"

const StyledImg = styled("img")({})

const WavelengthLogo = ({ sx }: { sx?: SxProps }) => {
  return <StyledImg sx={sx} src={WavelengthLogoSvg} />
}

export default WavelengthLogo
